import styled from '@emotion/styled';

import { transitions } from '../tokens';

export const spec = {
  size: 48,
  gap: 8,
  vazio: { borda: '#262626', texto: '#262626' },
  preenchido: { borda: '#000FFF', texto: '#000FFF' },
  erro: { borda: '#FF2929', texto: '#FF2929' },
  desabilitado: { borda: '#D9D9D9', texto: '#8C8C8C' },
  sucesso: '#4EC937',
} as const;

type EstadoProps = {
  erro: boolean;
  preenchido: boolean;
  desabilitado: boolean;
};

const cor = (
  { erro, preenchido, desabilitado }: EstadoProps,
  campo: 'borda' | 'texto'
): string => {
  if (desabilitado) return spec.desabilitado[campo];
  if (erro) return spec.erro[campo];
  return preenchido ? spec.preenchido[campo] : spec.vazio[campo];
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Circles = styled.div`
  display: flex;
  align-items: center;
  gap: ${spec.gap}px;

  @media (max-width: 380px) {
    gap: 4px;
  }
`;

export const Circle = styled.input<EstadoProps>`
  box-sizing: border-box;
  width: ${spec.size}px;
  height: ${spec.size}px;
  padding: 0;
  text-align: center;
  font-family: 'Mangueira', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  color: ${(p) => cor(p, 'texto')};
  background: transparent;
  border: 1px solid ${(p) => cor(p, 'borda')};
  border-radius: 50%;
  outline: none;
  transition: border-color ${transitions.base}, color ${transitions.base};

  &:focus-visible {
    border-width: 2px;
    border-color: ${spec.preenchido.borda};
  }

  &:disabled {
    cursor: not-allowed;
  }

  /* esconde as setas que alguns navegadores desenham em inputs numéricos */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  @media (max-width: 380px) {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
`;

export const Mensagem = styled.span<{ erro: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: ${({ erro }) => (erro ? spec.erro.texto : '#282828')};

  svg {
    width: 16px;
    height: 16px;
    color: ${({ erro }) => (erro ? spec.erro.borda : spec.sucesso)};
  }
`;
